import { UseQueryResult, useQuery } from 'react-query';

import { getTokenWithType } from './useAuth';

import { twilioBranchOutGroup } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

async function fetchBranchOutGroup(): Promise<APIResult> {
  const response = await fetch(twilioBranchOutGroup, {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  return response.json();
}

type TError = ErrorModal;

type APIResult = {
  IsSuccess: boolean;
  StatusCode: number;
  Data: Array<{
    Name: string;
    Description: string;
    Id: string;
  }>;
};

type TResult = Array<{
  id: number;
  name: string;
  description: string;
}>;

function useGetTwilioBranchOutGroup(): UseQueryResult<TResult, TError> {
  return useQuery(
    'get_twilio_branch_out_groups',
    async () => {
      const fetchResponse = await fetchBranchOutGroup();
      const result = fetchResponse?.Data?.map(item => ({
        id: item.Id,
        name: `${item.Name}`,
        description: `${item.Description}`,
      }));
      return result;
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetTwilioBranchOutGroup };
